import {Pipe, PipeTransform} from '@angular/core';

@Pipe({
  name: 'plural',
})
export class PluralPipe implements PipeTransform {
  public transform(value: number, singular: string, plural: string): string {
    return value === 1 ? singular : plural;
  }
}
